import debug from 'debug';

import { setKubbApiClient } from '@mi-front/api-clients';
import { BRAND_ASSETS_BASE } from '@mi-front/ui';
import { Inspector } from 'react-dev-inspector';
import ReactDOM from 'react-dom';
import 'react-loading-skeleton/dist/skeleton.css';
import 'video.js/dist/video-js.css';
import { apiClient as newApiClient } from './api';
import { config } from './config';
import { Root } from './core/containers/Root';
import './setup';
import './styles/ui.css';
debug.log = console.log.bind(console);
debug.enable('*');

const MOUNT_NODE = document.getElementById('root');

setKubbApiClient(newApiClient);

const favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (favicon) {
  favicon.href = config.isAppDev
    ? `${BRAND_ASSETS_BASE}/favicon-dev.png`
    : `${BRAND_ASSETS_BASE}/favicon.ico`;
}

const render = async () => {
  ReactDOM.render(
    <>
      {config.isNodeDev && <Inspector keys={['Control', 'Shift', 'C']} />}
      <Root />
    </>,
    MOUNT_NODE,
  );
};

render();

console.info(`MediaInbox UI ${config.appEnv.toUpperCase()} ${config.appVersion}`);
